import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function SportsPage() {
  const { t } = useTranslation(['nav', 'common']);

  return (
    <div className="page">
      <article className="state-card sports-empty">
        <h2>{t('nav:sports')}</h2>
        <p>{t('common:sportsUnavailable', { defaultValue: 'Live sports betting is not available yet. Casino games remain open.' })}</p>
        <Link to="/games" className="btn btn-primary">
          {t('nav:casino')}
        </Link>
      </article>
    </div>
  );
}
